import api from '@/modules/api'
import { IsValid } from '@/modules/helper/index'
import moment from 'moment'
import { reverse } from 'lodash'

export default {
  state: {
    analyticsResult: [],
    pageViewsResult: [],
    platformResult: {},
    appDownloadsForMonth: {},
    appDownloadsForLast12Month: {},
    appDownloadsForLast26Weeks: {},
    maxDate: null,
    pageViewsForMonth: {},
    pageViewsForLast12Month: {},
    pageViewsForLast26Weeks: {},
    dashboardAnalytics: {},
    webAppDownloads: 0,
    notificationCount: '',
    iOSDownloads: 0,
    androidDownloads: 0
  },
  getters: {
    analyticsResult: state => state.analyticsResult,
    pageViewsResult: state => state.pageViewsResult,
    platformResult: state => state.platformResult,
    appDownloadsForMonth: state => state.appDownloadsForMonth,
    appDownloadsForLast12Month: state => state.appDownloadsForLast12Month,
    appDownloadsForLast26Weeks: state => state.appDownloadsForLast26Weeks,
    maxDate: state => state.maxDate,
    pageViewsForMonth: state => state.pageViewsForMonth,
    pageViewsForLast12Month: state => state.pageViewsForLast12Month,
    pageViewsForLast26Weeks: state => state.pageViewsForLast26Weeks,
    dashboardAnalytics: state => state.dashboardAnalytics,
    notificationCount: state => state.notificationCount,
    webAppDownloads: state => state.webAppDownloads,
    iOSDownloads: state => state.iOSDownloads,
    androidDownloads: state => state.androidDownloads
  },
  mutations: {
    setAnalyticsResult (state, analyticsData) {
      state.analyticsResult = analyticsData
    },
    setPageViewsResult (state, pageViewsData) {
      state.pageViewsResult = pageViewsData
    },
    setPlatformResult (state, platformData) {
      state.platformResult = platformData
    },
    setPlatformCounts (state, payload) {
      state.webAppDownloads = payload.webAppDownloads
      state.iOSDownloads = payload.iOSDownloads
      state.androidDownloads = payload.androidDownloads
    },
    setAppDownloadsForMonth (state, appDownloadsForMonth) {
      state.appDownloadsForMonth = appDownloadsForMonth
    },
    setAppDownloadsForLast12Month (state, appDownloadsForLast12Month) {
      state.appDownloadsForLast12Month = appDownloadsForLast12Month
    },
    setAppDownloadsForLast26Weeks (state, appDownloadsForLast26Weeks) {
      state.appDownloadsForLast26Weeks = appDownloadsForLast26Weeks
    },
    setPageViewsForMonth (state, pageViewsForMonth) {
      state.pageViewsForMonth = pageViewsForMonth
    },
    setPageViewsForLast12Month (state, pageViewsForLast12Month) {
      state.pageViewsForLast12Month = pageViewsForLast12Month
    },
    setPageViewsForLast26Weeks (state, pageViewsForLast26Weeks) {
      state.pageViewsForLast26Weeks = pageViewsForLast26Weeks
    },
    setMaxDate (state, maxDate) {
      state.maxDate = maxDate
    },
    setNotificationCount (state, notificationCount) {
      state.notificationCount = notificationCount
    },
    setDashboardAnalytics (state, payload) {
      state.dashboardAnalytics = payload
    }
  },
  actions: {
    async populateStatasticData ({ commit, rootGetters }, payload) {
      const response = await api.Analytics.GetOverviewNPlatformInfo(payload)
      if (IsValid(response)) {
        if (IsValid(response.PlatformResult, true)) {
          let downloads = response.PlatformResult
          let total = parseInt(downloads[0].AppDownloads) + parseInt(downloads[1].AppDownloads) + parseInt(downloads[2].AppDownloads)
          const webapp = downloads[0].AppDownloads > 0 ? Math.round((downloads[0].AppDownloads / total) * 100) : 0
          const ios = downloads[1].AppDownloads > 0 ? Math.round((downloads[1].AppDownloads / total) * 100) : 0
          const android = downloads[2].AppDownloads > 0 ? Math.round((downloads[2].AppDownloads / total) * 100) : 0
          let payload = {
            'labels': [ `${webapp}%`,
              `${ios}%`,
              `${android}%`],
            'series': [ response.PlatformResult[0].AppDownloads,
              response.PlatformResult[1].AppDownloads,
              response.PlatformResult[2].AppDownloads ]
          }
          commit('setPlatformResult', payload)

          const counts = {
            webAppDownloads: response.PlatformResult[0].AppDownloads,
            iOSDownloads: response.PlatformResult[1].AppDownloads,
            androidDownloads: response.PlatformResult[2].AppDownloads
          }
          commit('setPlatformCounts', counts)
        }

        if (IsValid(response.AppDownloadsForLast12Month, true)) {
          let labels = []
          let series = []
          moment.locale(rootGetters.user.Language.toLowerCase())
          const monthArray = Array.apply(0, Array(12)).map(function (_, i) { return moment().month(i).format('MMM') })
          response.AppDownloadsForLast12Month.forEach(data => {
            labels.push(`${monthArray[data.DownloadMonth - 1]} ${data.DownloadYear.toString().substr(-2)}`)
            series.push(data.DownloadsPerMonth)
          })

          let payload = {
            'labels': labels,
            'series': [ series ]
          }
          commit('setAppDownloadsForLast12Month', payload)
        } else {
          commit('setAppDownloadsForLast12Month', { })
        }
        if (IsValid(response.PageViewsForLast12Month, true)) {
          let labels = []
          let series = []
          response.PageViewsForLast12Month.forEach(data => {
            labels.push(data.PageTitle)
            series.push(data.PageView)
          })

          let payload = {
            'labels': labels,
            'series': [ series ]
          }
          commit('setPageViewsForLast12Month', payload)
        } else {
          commit('setPageViewsForLast12Month', { })
        }

        if (IsValid(response.AppDownloadsForLast26Weeks, true)) {
          let labels = []
          let series = []
          let reversedData = reverse(response.AppDownloadsForLast26Weeks)
          reversedData.forEach(data => {
            labels.push(data.WeekName)
            series.push(data.asDownloadCount)
          })

          let payload = {
            'labels': labels,
            'series': [ series ]
          }
          commit('setAppDownloadsForLast26Weeks', payload)
        } else {
          commit('setAppDownloadsForLast26Weeks', { })
        }

        if (IsValid(response.PageViewsForLast26Weeks, true)) {
          let labels = []
          let series = []
          response.PageViewsForLast26Weeks.forEach(data => {
            labels.push(data.PageTitle)
            series.push(data.PageView)
          })

          let payload = {
            'labels': labels,
            'series': [ series ]
          }
          commit('setPageViewsForLast26Weeks', payload)
        } else {
          commit('setPageViewsForLast26Weeks', { })
        }

        if (IsValid(response.AnalyticsResult, true)) {
          commit('setAnalyticsResult', response.AnalyticsResult[0])
          commit('setPageViewsResult', response.AnalyticsResult[0])
        }

        if (IsValid(response.AppDownloadsForMonth, true)) {
          let labels = []
          let series = []
          response.AppDownloadsForMonth.forEach(data => {
            labels.push(data.Row_)
            series.push(data.DownloadsPerDay)
          })
          let payload = {
            'labels': labels,
            'series': [ series ]
          }
          commit('setAppDownloadsForMonth', payload)
        } else {
          commit('setAppDownloadsForMonth', { })
        }

        if (IsValid(response.PageViewsFortheMonth, true)) {
          let labels = []
          let series = []
          response.PageViewsFortheMonth.forEach(data => {
            labels.push(data.PageTitle)
            series.push(data.PageView)
          })
          let payload = {
            'labels': labels,
            'series': [ series ]
          }
          commit('setPageViewsForMonth', payload)
        } else {
          commit('setPageViewsForMonth', { })
        }

        if (IsValid(response.MaxDate, true)) {
          commit('setMaxDate', response.MaxDate)
        }
      }
    },
    async populateDailyAppDownloadsChart ({ commit, rootGetters }, payload) {
      const response = await api.Analytics.GetDailyAppDownloads(payload)
      if (IsValid(response, true)) {
        let labels = []
        let series = []
        response.forEach(data => {
          labels.push(data.Row_)
          series.push(data.DownloadsPerDay)
        })
        let payload = {
          'labels': labels,
          'series': [ series ]
        }
        commit('setAppDownloadsForMonth', payload)
      } else {
        commit('setAppDownloadsForMonth', {})
      }
    },
    async populateDailyPageViewsChart ({ commit, rootGetters }, payload) {
      const response = await api.Analytics.GetDailyPageViews(payload)
      if (IsValid(response, true)) {
        let labels = []
        let series = []
        response.forEach(data => {
          labels.push(data.PageTitle)
          series.push(data.PageView)
        })
        let payload = {
          'labels': labels,
          'series': [ series ]
        }
        commit('setPageViewsForMonth', payload)
      } else {
        commit('setPageViewsForMonth', {})
      }
    },
    async populateMonthlyPageViewsChart ({ commit, rootGetters }, payload) {
      const response = await api.Analytics.GetMonthlyPageViews(payload)
      if (IsValid(response, true)) {
        let labels = []
        let series = []
        response.forEach(data => {
          labels.push(data.PageTitle)
          series.push(data.PageView)
        })
        let payload = {
          'labels': labels,
          'series': [ series ]
        }
        commit('setPageViewsForLast12Month', payload)
      } else {
        commit('setPageViewsForLast12Month', {})
      }
    },
    async populateWeeklyPageViewsChart ({ commit, rootGetters }, payload) {
      const response = await api.Analytics.GetMonthlyPageViews(payload)
      if (IsValid(response, true)) {
        let labels = []
        let series = []
        response.forEach(data => {
          labels.push(data.PageTitle)
          series.push(data.PageView)
        })
        let payload = {
          'labels': labels,
          'series': [ series ]
        }
        commit('setPageViewsForLast26Weeks', payload)
      } else {
        commit('setPageViewsForLast26Weeks', {})
      }
    },
    async populateDashboardAnalytics ({ commit, rootGetters }) {
      const today = new Date()
      let payload = {
        Subscription_Id: rootGetters.subscription.Id,
        Year: today.getFullYear(),
        Month: today.getMonth() + 1,
        Day: today.getDate()
      }
      const response = await api.Analytics.GetDashboardAnalytics(payload)
      if (IsValid(response)) {
        commit('setDashboardAnalytics', response[0])
      } else {
        commit('setDashboardAnalytics', {})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/analytics.js